import { CardAction } from "@/shared/components/common/Card";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import { Button } from "@/shared/components/common/button";
import type { MinPriceRoom } from "@/types/services/hotel/apis/Detail";
import useCountRooms from "../useCountRooms";
import RoomCardCounter from "./RoomCardCounter";

interface RoomCardActionProps {
  room: MinPriceRoom;
  label: string;
  limitLabel: string;
}

export default function RoomCardAction({
  room,
  label,
  limitLabel,
}: RoomCardActionProps) {
  const limit = 4;
  const roomsProps = useCountRooms(room, limit);
  const { countRooms, currentRoomCount, totalRoomCount } = roomsProps;
  const handleSelectRoom = () => totalRoomCount < limit && countRooms(1);

  return (
    <CardAction>
      <Flex alignItems={"center"} gap={"2"}>
        <Flex alignItems={"center"} gap={"1"}>
          {currentRoomCount > 0 ? (
            <RoomCardCounter room={room} {...roomsProps} limit={limit} />
          ) : (
            <Button
              className={"rounded-full px-10 py-5 animate-fade-in"}
              onClick={handleSelectRoom}
              disabled={totalRoomCount === limit}
              data-analytics-event="hotel_room_selected"
              data-analytics-id={`hotel-detail-room-${room.id}-${room.rate_plans.id}`}
              data-analytics-name={room.name}
              data-analytics-type="button"
              data-analytics-funnel="hotel_booking"
              data-analytics-step="detail_room_select"
              data-analytics-property-room-id={room.id}
              data-analytics-property-rate-plan-id={room.rate_plans.id}
              data-analytics-property-room-name={room.name}
              data-analytics-property-price={String(room.rate_plans.price)}
            >
              <Typography
                variant={"body1"}
                fontWeight={"medium"}
                className="text-background dark:text-foreground"
              >
                {totalRoomCount < limit ? label : limitLabel}
              </Typography>
            </Button>
          )}
        </Flex>
      </Flex>
    </CardAction>
  );
}
